import * as styles from "./WindowContent.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import type { WindowContentProps } from "./Window.types";

export function WindowContent({
  className,
  ...props
}: WindowContentProps): JSX.Element {
  return (
    <div
      data-slot="window-content"
      className={clsx(styles.content, className)}
      {...props}
    />
  );
}
